import gridPortraitViewTpl from 'templates/carousels/__gridPortraitView.tpl';
import noDataTpl from 'templates/__noData.tpl';
import Breakpoints from 'helpers/breakpoints';
import 'carousels/helpers/ellipsify';

export default function (customOptions = {}) {
    const noDataMessage = customOptions.options.noDataMessage
        ? customOptions.options.noDataMessage
        : 'No data available.';
    const noResizeListener = customOptions.options.noResizeListener
        ? customOptions.options.noResizeListener
        : false;

    const parentContainer = customOptions.parentContainer;
    const container = parentContainer.find('.grid-view-container');
    const b = new Breakpoints();
    let currentBreakpoint = b.getCurrentBreakpointName();
    let currentItemsPage = 0;
    let isFirstLoad = true;
    let hasResized = false;
    let list = [];
    let currentIdx = 0;
    let currentArticleHeight = 0;
    let currentParams = null;
    let total = null;
    const LOAD_SIZE = 50;

    const loadSizes = {
        desktopWide: 48,
        desktop: 48,
        tabletLandscape: 48,
        globalNavTabletLandscape: 36,
        globalNavTabletPortrait: 30,
        mobileLandscape: 24,
        mobilePortrait: 18,
    };

    const rowsByBreakpoint = {
        mobilePortrait: 4,
        mobileLandscape: 2,
        globalNavTabletPortrait: 2,
        globalNavTabletLandscape: 2,
        tabletPortrait: 2,
        tabletLandscape: 2,
        desktop: 2,
        desktopWide: 2,
    };

    const getRowsByBreakpoint = function () {
        return rowsByBreakpoint[b.getCurrentBreakpointName()];
    };

    //getLoadSize is used to know how many to put into the dom
    const getLoadSize = function () {
        return loadSizes[b.getCurrentBreakpointName()] || LOAD_SIZE;
    };

    const getGridItems = function (callback) {
        const limit = getLoadSize();
        const itemsOffset = currentItemsPage * limit;
        const endpoint = buildEndpoint({
            page: currentItemsPage,
            // clips grid xhr request uses these params
            offset: itemsOffset,
            limit: limit,
        });

        const willBeLastLoad = itemsOffset >= total;
        if (!isFirstLoad && willBeLastLoad) {
            loadListFromIndex(currentIdx + 1, total, true);
        } else {
            $.ajax({
                type: 'GET',
                url: endpoint,
                dataType: 'json',
                success: function (resp) {
                    if (resp?.result && resp?.result?.data) {
                        if (total === null) {
                            setTotal(resp.result.total);
                        }
                        appendList(resp);
                        if (callback) {
                            callback();
                        } else {
                            handleFirstLoad();
                        }
                    }
                },
            });
        }
    };

    const buildEndpoint = function (merge) {
        let params = Object.assign({}, currentParams, merge);

        if (currentParams === null) {
            // default params
            const limit = getLoadSize();
            currentParams = {
                slug: parentContainer.data('slug'),
                page: currentItemsPage,
                size: limit,
            };

            params = Object.assign(currentParams, customOptions.options.params, merge);
        }

        currentParams = params;

        let endpoint = customOptions.options.endPoint;
        for (let property in params) {
            if (params.hasOwnProperty(property)) {
                endpoint = endpoint.replace('{' + property + '}', params[property]);
            }
        }

        return endpoint;
    };

    const appendList = function (resp) {
        resp.result.data.forEach((obj) => {
            list.push(obj);
        });
    };

    const handleFirstLoad = function () {
        if (hasResized) {
            removeAll();
        }
        loadListFromIndex(0, null, false);
    };

    const removeAll = function () {
        container.find('article.grid-view-item').remove();
    };

    const handleResize = function () {
        hasResized = true;
        setProgressBarAlreadyRendered();
        const resizedBreakpoint = b.getCurrentBreakpointName();
        if (currentBreakpoint !== resizedBreakpoint) {
            currentBreakpoint = resizedBreakpoint;
            if (isFirstLoad) {
                handleFirstLoad();
            } else {
                reloadAll();
            }
        }
    };

    const setProgressBarAlreadyRendered = function () {
        list.forEach((item, idx) => {
            if (!item.hasRendered) {
                item.hasRendered = true;
            }
        });
    };

    const reloadAll = function () {
        removeAll();
        loadListFromIndex(0, list.length, false);
    };

    const loadListFromIndex = function (from, to, doAnimation) {
        doAnimation = doAnimation === true;

        // fill dom
        const opacity = doAnimation === true ? 0 : 1;
        const loadSize = getLoadSize();
        const max = to ? to : from + loadSize;

        if (list.length > 0) {
            for (let i = from; i < max && i < total; i++) {
                if (typeof list[i] !== 'undefined') {
                    currentIdx = i;
                    list[i].carouselModel = customOptions.options?.carouselModel;
                    container.append(
                        $(gridPortraitViewTpl(list[i])).css({
                            opacity: opacity,
                        }),
                    );
                }
            }
        } else {
            container.append(
                $(noDataTpl())
                    .css({
                        opacity: opacity,
                    })
                    .text(noDataMessage),
            );
        }

        if (CBS.Registry.lazyImage) {
            setTimeout(() => {
                CBS.Registry.lazyImage.revalidate();
            }, 200);
        }

        // fill holes if necessary
        const totalArticles = container.find('article.grid-view-item').length;
        const needsMore = totalArticles < total;

        if (needsMore) {
            handleNeedsMore();
        } else {
            if (doAnimation) {
                animateContainer();
            }
            container.ellipsify();
        }
    };

    const animateContainer = function () {
        const _getGap = function () {
            let gap;

            // chrome
            if (!gap) {
                gap = container.css('gap');
                if (gap) {
                    gap = parseInt(gap.split(' ')[0]);
                }
            }

            // firefox
            if (!gap) {
                gap = container.css('row-gap');
                if (gap) {
                    gap = gap.replace('px', '');
                }
            }

            // safari
            if (!gap) {
                gap = container.css('grid-gap');
                if (gap) {
                    gap = parseInt(gap.replace('/ ', ''));
                }
            }

            // no gap found
            if (!gap) {
                gap = 0;
            }

            return gap;
        };

        // prep to animate container
        container.css({
            height: container.height(),
        });

        currentArticleHeight = 0;
        const articles = container.find('article');
        articles.each(() => {
            const h = $(this).height();
            if (h > currentArticleHeight) {
                currentArticleHeight = h;
            }
        });

        const rows = getRowsByBreakpoint();
        const increase = currentArticleHeight * rows + _getGap();

        // animate grid container
        container.animate(
            {
                height: container.height() + increase,
            },
            300,
            () => {
                // set grid back to auto to adjust (this is in case there's only 1 line of copy for the title across row 1 OR 2, so there's proper spacing below grid container)
                container.css({
                    height: 'auto',
                });

                // fade in grid items
                container.find('article').delay(300).animate(
                    {
                        //
                        opacity: 1,
                    },
                    300,
                );
            },
        );
    };

    const handleNeedsMore = function () {
        const currentItemsCount = container.find('article.grid-view-item').length;
        const itemsToLoad = total - currentItemsCount;

        if (itemsToLoad > 0) {
            const from = currentIdx + 1;
            const loadMore = function () {
                // was false, testing smoothness
                loadListFromIndex(from, null, false);
            };

            const moreItemsToLoad = currentItemsCount + itemsToLoad <= list.length;
            if (moreItemsToLoad) {
                loadMore();
            } else {
                currentItemsPage++;
                getGridItems(loadMore);
            }
        }
    };

    const setTotal = function (tot) {
        total = tot;
        container.data('total', tot);
    };

    const trackingGridItem = function ($target) {
        const gridLink = $($target.closest('a'));
        const gridContainer = $($target.closest('section.grid-view'));
        const aaLink = gridLink.attr('aa-link').split('|');
        const hubPageType = __hub?.hubPageType ?? utag_data?.hubPageType ?? '';
        const hubSlug = __hub?.hubSlug ?? utag_data?.hubSlug ?? '';
        const hubId = __hub?.hubId ?? utag_data?.hubId ?? '';
        const pageType = __hub?.pageType ?? utag_data?.pageType ?? '';
        const screenName = utag_data?.screenName ?? '';
        const carouselId =
            gridContainer.attr('data-carouselId') && gridContainer.attr('data-carouselId') !== ''
                ? gridContainer.attr('data-carouselId')
                : gridContainer.attr('id');
        const carouselContentType = aaLink[25] ?? '';
        const carouselModel = gridContainer.attr('data-model') ?? '';
        const carouselLink = gridLink.attr('href') ?? '';
        const isHighlightEnabled = gridContainer.attr('data-isContentHighlightEnabled');
        const videoPreviewId = gridLink.attr('data-videoContentId') ?? gridLink.attr('id');
        const action = 'trackHubRowHeader';
        let obj = null;

        obj = {
            hubPageType,
            hubSlug,
            hubId,
            pageType,
            screenName,
            carouselId,
            carouselContentType: aaLink[25] ?? '',
            carouselModel,
            carouselLink,
            carouselPresentationStyle: customOptions.options.carouselPresentationStyle,
            isHighlightEnabled,
            videoPreviewId,
        };

        if (carouselContentType === 'movie') {
            obj.movieId = aaLink[16];
            obj.movieTitle = aaLink[5] ? aaLink[5] : aaLink[1];
        } else {
            obj.showSeriesId = gridLink.attr('data-showId') ?? '';
            obj.showSeriesTitle = aaLink[4] ?? '';
            obj.showGenre = aaLink[15];
        }

        try {
            om.trackAction(action, obj);
        } catch (e) {
            console.error(action + ' failed to load');
        }
    };

    if (parentContainer.length > 0) {
        $(document).ready(function () {
            getGridItems();

            if (!noResizeListener) {
                window.addEventListener('resize', handleResize);
            }

            $(container).on('click', '.grid-view-item a', function (e) {
                e.preventDefault();
                trackingGridItem($(this));
                location.href = $(this).attr('href');
            });
        });
    }
}
